{
  "jira-forms-conditional-fields-changeboarding.spotlight.body.no-translate": [
    {
      "type": 0,
      "value": "Create conditions to have more control over the information you receive."
    }
  ],
  "jira-forms-conditional-fields-changeboarding.spotlight.heading.no-translate": [
    {
      "type": 0,
      "value": "Show fields based on previous responses"
    }
  ],
  "jira-forms-conditional-fields-changeboarding.spotlight.ok.no-translate": [
    {
      "type": 0,
      "value": "Ok"
    }
  ],
  "jira-tanuki.jira-forms-public-forms-changeboarding-flag.screen-space-flags.description.no-translate": [
    {
      "type": 0,
      "value": "Jira Forms can now be shared publicly with anyone online. You can also customize forms by adding conditions."
    }
  ],
  "jira-tanuki.jira-forms-public-forms-changeboarding-flag.screen-space-flags.title.no-translate": [
    {
      "type": 0,
      "value": "Public forms available now"
    }
  ],
  "jira-tanuki.jira-forms-public-forms-changeboarding.screen-space-flags.description.no-translate": [
    {
      "type": 0,
      "value": "Jira Forms can now be shared publicly, so you can receive responses from anyone online and collect work for your team in real time. You can also customize forms by adding conditions and setting required fields."
    }
  ],
  "jira-tanuki.jira-forms-public-forms-changeboarding.screen-space-flags.title.no-translate": [
    {
      "type": 0,
      "value": "Public forms available now"
    }
  ],
  "jira-tanuki.jira-in-context-config-sidebar-changeboarding.screen-space-flags.description.no-translate": [
    {
      "type": 0,
      "value": "From the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "All work"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " tab, you can now use currency or percentage formatting for a number field."
    }
  ],
  "jira-tanuki.jira-in-context-config-sidebar-changeboarding.screen-space-flags.title.no-translate": [
    {
      "type": 0,
      "value": "Introducing currency formatting"
    }
  ]
}